<template>
  <h1>
    <span v-html="h1" />
    <tooltip v-if="tooltip !== null" :content="tooltip" />
  </h1>
</template>

<script>
import Tooltip from '@/components/UI/Tooltip.vue';

export default {
  name: 'H1AndTooltip',
  components: { Tooltip },
  props: {
    h1: {
      type: String,
      default() {
        return null;
      }
    },
    tooltip: {
      type: String,
      default() {
        return null;
      }
    }
  }
};
</script>
